module.exports = __webpack_public_path__ + "img/20200102155256059.49d9e978.jpg";